import styled, { keyframes } from 'styled-components'

import A from '../A'
import { mq, sizes } from '../../theme'

const fadeIn = keyframes`
 0% { opacity: 0; }
 100% { opacity: 1; }
`

export const Container = styled.div`
  position: relative;
  align-self: center;
  width: 100%;

  @media ${mq(sizes.desktop)} {
    max-width: 83rem;
  }
`

export const Video = styled.div`
  display: flex;
  position: relative;
  height: auto;
  overflow: hidden;
  border-radius: 2rem;
  width: 100%;
  max-width: 83rem;
`

export const VideoDuration = styled.div`
  ${({ theme }) => theme.textStyles.text_bold_condensed_16}
  background: ${({ theme }) => theme.colors.pink};
  padding: 2.5rem;
  top: 0;
  right: 0;
  position: absolute;
  z-index: 1;
`

export const VideoElement = styled.video`
  display: flex;
  position: relative;
  width: 100%;
  height: auto;
  object-fit: cover;
  outline: none;
`

export const ToggleTranscript = styled(A)`
  display: flex;
  margin-left: auto;
  margin-top: 2rem;
  justify-self: flex-end;
  ${({ theme }) => theme.textStyles.text_medium_16}
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-color: ${({ theme }) => theme.colors.pureBlack};
  text-decoration-thickness: 2px;
  text-underline-position: under;

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_medium_18}
  }
`
export const Transcript = styled.div`
  color: ${({ theme }) => theme.colors.pureBlack};
  ${({ theme }) => theme.textStyles.text_medium_16}
  line-height: 2.5rem;
  margin-top: 2rem;
  opacity: 0;
  animation-name: ${fadeIn};
  animation-duration: 0.6s;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_medium_18}
  }
`
